export default __webpack_public_path__ + "static/media/image10.81e9e038.jpg";